// Storefront promotion banner + checkout discount code countdown.
//
// Bridge (Sales > Promotions) is the source of truth for the discount codes.
// Its shopify:promotions-sync command publishes promo-banner.js to the store's
// Content > Files; theme.liquid loads that file (file_url filter) right before
// this one. It defines:
//
//   window.TD_PROMO = {
//     generated_at: "2026-11-05T09:00:00-05:00",
//     promotions: [{ code, name, description, type: "percent" | "dollar",
//                    value, min_amount, starts_at, ends_at }, ...]
//   }
//
// The list carries the enabled codes that have not ended yet, live and
// scheduled, soonest end first. This script picks the one live right now,
// renders the banner into #promoBox with the markup Bridge used to serve from
// /promotion/banner, and counts down to its end once a minute. A scheduled code
// appears at its start and a live one disappears at its end without any new
// file; nothing is requested from Bridge per page view.
(function () {
  var TICK = 60000;
  var box = null;
  var shown = null;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // $250 for a whole amount, $249.99 otherwise.
  function money(amount) {
    amount = Number(amount) || 0;
    var whole = Math.floor(amount) === amount;
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
  }

  // 5 -> "5%", 12.5 -> "12.5%".
  function percent(value) {
    return String(Number(value) || 0) + '%';
  }

  // "2d 3h" / "9h 24min" / "24min".
  function timeLeft(ms) {
    var minutes = Math.max(0, Math.floor(ms / 60000));
    var days = Math.floor(minutes / 1440);
    var hours = Math.floor((minutes % 1440) / 60);
    var mins = minutes % 60;

    if (days > 0) {
      return days + 'd ' + hours + 'h';
    }
    if (hours > 0) {
      return hours + 'h ' + mins + 'min';
    }
    return mins + 'min';
  }

  function promotions() {
    var data = window.TD_PROMO;
    return data && data.promotions && data.promotions.length ? data.promotions : [];
  }

  // The promotion live at `now`: soonest end first, larger discount on a tie.
  function live(now) {
    var all = promotions();
    var list = [];

    for (var i = 0; i < all.length; i++) {
      var p = all[i];
      var starts = Date.parse(p.starts_at);
      var ends = Date.parse(p.ends_at);

      if (isNaN(starts) || isNaN(ends)) {
        continue;
      }
      if (starts <= now && now < ends) {
        list.push(p);
      }
    }

    list.sort(function (a, b) {
      return (Date.parse(a.ends_at) - Date.parse(b.ends_at))
        || ((Number(b.value) || 0) - (Number(a.value) || 0));
    });

    return list[0] || null;
  }

  // Same markup Bridge's resources/views/shopify/promo-box.blade.php rendered.
  function render(p, now) {
    var off = (p.type === 'dollar' ? money(p.value) : percent(p.value)) + ' OFF ENTIRE STORE';
    var min = Number(p.min_amount) > 0 ? ' - ON ORDERS ' + money(p.min_amount) + '+ / ' : ' - ';

    var html = ''
      + '<div class="promo-box" style="background: rgb(255, 98, 2);">'
      +   '<div class="container">'
      +     '<div class="py-2 text-white d-md-flex justify-content-between">'
      +       '<div>'
      +         (p.description ? esc(p.description) + ' - ' : '')
      +         '<b>' + esc(off) + '</b>' + esc(min)
      +         'USE CODE <strong>' + esc(p.code) + '</strong> AT CHECKOUT'
      +       '</div>'
      +       '<div class="promo-counter mt-2 mt-md-0">'
      +         '<span class="fa fa-clock mr-2" aria-hidden="true"></span>'
      +         '<span class="font-weight-bold date mr-1">' + timeLeft(Date.parse(p.ends_at) - now) + '</span> left'
      +       '</div>'
      +     '</div>'
      +   '</div>'
      + '</div>';

    box.html(html);
  }

  function tick() {
    var now = Date.now();
    var p = live(now);

    if (!p) {
      if (shown) {
        box.empty();
        shown = null;
      }
      return;
    }

    if (shown !== p.code) {
      render(p, now);
      shown = p.code;
      return;
    }

    box.find('.promo-counter .date').text(timeLeft(Date.parse(p.ends_at) - now));
  }

  window.initCountdown = function () {
    if (typeof myjQuery === 'undefined') {
      return;
    }

    box = myjQuery('#promoBox');

    if (!box.length || !promotions().length) {
      return;
    }

    tick();
    setInterval(tick, TICK);
  };
})();
